import { Checkbox, Typography, Stack } from '@mui/material';

import DOMPurify from 'dompurify';

import {
	checkAllChildrenSelected,
	checkAnyChildrenSelected,
} from 'features/RegulationInventory/RegulationGroup/RegulationGroupUtil';

import {
	ICitationDetailsElements,
	ISelectedCitationGroups,
} from '../../api/type-def';

import styles from './CitationDescription.module.scss';

const { checkboxCheckedcolor, checkboxUncheckedcolor } = styles;

type ICitationDescriptionDetails = {
	currentNode: ICitationDetailsElements;
	parentNode: ICitationDetailsElements | null;
	checkedCitations?: ISelectedCitationGroups[];
	handleCheckBox?: (
		event: React.ChangeEvent<HTMLInputElement>,
		res: any,
		parent?: any,
	) => void;
	isMultiCheckBoxRequired?: boolean;
};

const CitationDescription = (props: ICitationDescriptionDetails) => {
	const {
		currentNode,
		parentNode,
		isMultiCheckBoxRequired,
		handleCheckBox,
		checkedCitations = [],
	} = props;

	const { regulation, summary, children } = currentNode;

	return (
		<div>
			{regulation && summary && (
				<Typography className={styles['component-padding-summary']}>
					<div
						dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(summary) }}
					/>
				</Typography>
			)}
			{children?.map((citationNode: ICitationDetailsElements) => {
				const { id, description } = citationNode;

				const selectedNode = checkedCitations.some(
					(node) => node.citationId === id,
				);

				return (
					<div
						key={`citation-description-${id}`}
						className={styles['component-padding']}
					>
						<Stack
							direction="row"
							justifyContent="flex-start"
							alignItems="flex-start"
						>
							{isMultiCheckBoxRequired && (
								<Checkbox
									size="small"
									checked={selectedNode}
									data-testid="checkbox-citation-description"
									indeterminate={
										checkAnyChildrenSelected(checkedCitations, citationNode) &&
										!checkAllChildrenSelected(checkedCitations, citationNode)
									}
									onChange={(e) => {
										if (handleCheckBox)
											handleCheckBox(e, citationNode, parentNode);
									}}
									sx={{
										paddingTop: '2px',
										color: checkboxUncheckedcolor,
										'&.Mui-checked': { color: checkboxCheckedcolor },
										'&.MuiCheckbox-indeterminate': {
											color: checkboxCheckedcolor,
										},
									}}
								/>
							)}
							<Typography
								className={styles['text-padding']}
								style={{ backgroundColor: 'inherit' }}
							>
								<div
									dangerouslySetInnerHTML={{
										__html: DOMPurify.sanitize(description),
									}}
								/>
							</Typography>
						</Stack>
						<CitationDescription
							currentNode={citationNode}
							key={id}
							parentNode={parentNode}
							{...(isMultiCheckBoxRequired
								? {
										isMultiCheckBoxRequired,
										handleCheckBox,
										checkedCitations,
								  }
								: {})}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default CitationDescription;
